import { createUserWithEmailAndPassword, onAuthStateChanged, signInWithEmailAndPassword, signOut as firebaseSignOut, updateProfile } from 'firebase/auth';
import type { User } from 'firebase/auth';
import { auth } from './client';
import { profileRepository } from './profileRepository';

export interface AuthRepository {
  signIn: (email: string, password: string) => Promise<unknown>;
  signUp: (email: string, password: string, displayName: string, role?: string) => Promise<unknown>;
  signOut: () => Promise<void>;
  onAuthChange: (callback: (user: User | null) => void) => () => void;
}

export const authRepository: AuthRepository = {
  signIn(email, password) {
    return signInWithEmailAndPassword(auth, email, password);
  },

  async signUp(email, password, displayName, role = 'user') {
    const cred = await createUserWithEmailAndPassword(auth, email, password);
    await updateProfile(cred.user, { displayName });
    await profileRepository.setProfile(cred.user.uid, { display_name: displayName, role, email });
    return cred;
  },

  signOut() {
    return firebaseSignOut(auth);
  },

  onAuthChange(callback) {
    return onAuthStateChanged(auth, callback);
  },
};
